import PropTypes from 'prop-types'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import { Banner } from 'SRC/modules/ads/detail/components/PhotosMobile/Banner'
import { ImageTags } from '../Photos/ImageTags'

export const PhotosMobile = ({ images, title, currentImage, onClick, imageTags, deliveryInfo }) => {
	const [selectedItem, setSelectedItem] = React.useState(0)

	React.useEffect(() => {
		setSelectedItem(0)
	}, [])

	React.useEffect(() => {
		if (currentImage !== undefined) {
			setSelectedItem(currentImage)
		}
	}, [currentImage])

	if (!Array.isArray(images)) return null

	return (
		<Carousel
			showThumbs={false}
			selectedItem={selectedItem}
			onChange={itemIndex => { setSelectedItem(itemIndex) }}
			showIndicators={false}
			showStatus={false}
			onClickItem={itemIndex => onClick(itemIndex)}
			interval={3000000}
			preventMovementUntilSwipeScrollTolerance={true}
			swipeScrollTolerance={50}
			className='vehicle-part-product-summary__photos-carousel'
		>
			{images.map(imageItem => (
				<div key={`image-${imageItem.id}`} style={{ position: 'relative' }}>
					<img src={imageItem.src} alt={title} style={{ objectFit: 'contain', aspectRatio: '4/3' }} />
					<ImageTags imageTags={imageTags} />
				</div>
			))}

			<div key='banner' style={{ height: '100%' }}>
				{selectedItem === images.length - 1 ? <Banner key='banner' /> : null}
			</div>
		</Carousel>
	)
}

PhotosMobile.propTypes = {
	images: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		src: PropTypes.string.isRequired,
	})).isRequired,
	title: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	currentImage: PropTypes.number,
	imageTags: PropTypes.array,
	deliveryInfo: PropTypes.object
}
